import { render } from "./LayersArea.vue?vue&type=template&id=8062edf4"
import script from "./LayersArea.vue?vue&type=script&lang=js"
export * from "./LayersArea.vue?vue&type=script&lang=js"

import "./LayersArea.vue?vue&type=style&index=0&id=8062edf4&lang=css"
script.render = render

export default script